import React, { Fragment, useState } from "react";
import styled from "styled-components";
import { ContainerNew, SubMenu } from "../Layout";
import { _O } from "../../modules/utils";

export default () => {
  const [checkYn, setCheckYn] = useState("Y");

  return (
    <Fragment>
      <ContainerNew
        Title={"로그인"}
        dark={"dark"}
        leftMenu={SubMenu}
        rightMenu={-1}
        isMain={true}
      >
        <Contents>
          <SubTitle>회원가입</SubTitle>

          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "20px", marginTop: "53px" }}>
              의료진의 대면 확인이 필요합니다
              <br />
              병원 내부에 계신가요?
            </div>

            <div
              style={{
                display: "flex",
                marginTop: "20px",
                padding: "0px 40px",
              }}
            >
              <SelectBtn
                active={checkYn === "Y" ? true : false}
                align="left"
                onClick={() => _O.Open("/membership/serviceTerms/500")}
              >
                예
              </SelectBtn>
              <SelectBtn
                active={checkYn === "N" ? true : false}
                align="right"
                onClick={() => alert("SMS인증")}
              >
                아니요
              </SelectBtn>
            </div>
          </div>
        </Contents>
        {/* <BottomBtnArea>
          <BtnNext
            onClick={() => {
              checkYn === "Y"
                ? _O.Open("/membership/serviceTerms")
                : alert("폰 확인으로 이동");
            }}
          >
            다음
          </BtnNext>
        </BottomBtnArea> */}
      </ContainerNew>
    </Fragment>
  );
};

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};

const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 37px;
`;

const SelectBtn = styled.div`
  width: 120px;
  height: 42px;
  line-height: 42px;
  border: ${(props) =>
    props.active ? "1px solid #6200EE" : "1px solid #C5C4C4"};
  border-radius: 8px;
  margin-left: ${(props) => (props.align === "left" ? "0" : "auto")};
`;

const BtnNext = styled.div`
  bottom: 86px;
  width: ${(props) => window.innerWidth - 30}px;
  height: 50px;
  line-height: 50px;
  background: #000000 0% 0% no-repeat padding-box;
  color: #fff;
  border-radius: 4px;
  opacity: 1;
  font-size: 17px;
`;
